/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTileBase_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"QuickViewItem_itemSearch">;
    readonly " $refType": "ItemTileBase_itemSearch";
};
export type ItemTileBase_itemSearch$data = ItemTileBase_itemSearch;
export type ItemTileBase_itemSearch$key = {
    readonly " $data"?: ItemTileBase_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTileBase_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "QuickViewItem_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '8fbf30901fa224c656bf72ef4f5a1474';
export default node;
